import React from "react"
import { Box } from "@chakra-ui/react"

import Icon from "@components/Icon/Icon"

const VideoPlayButton = () => (
  <Box
    w={["60px", "100px"]}
    h={["60px", "100px"]}
    borderRadius="full"
    bg="brand.navy.light"
    pos="absolute"
    left="50%"
    top="50%"
    transform="translate(-50%, -50%)"
  >
    <Icon
      name="play"
      pos="absolute"
      width={["38px", "64px"]}
      height={["29px", "48px"]}
      top="50%"
      left="60%"
      transform="translate(-60%, -50%)"
    />
  </Box>
)

export default VideoPlayButton
